/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import ReactDOMServer from 'react-dom/server';
import classnames from 'classnames';
import * as React from 'react';

import { INativeImageProps, INativeImageState, NativeImage } from './native-image';
import msdyn365Commerce from '../../..';

/**
 * Configuration for the main image.
 */
export interface IMainImageProps extends INativeImageProps {}

/**
 * State of the main image.
 */
export interface IMainImageState extends INativeImageState {}

/**
 * React component responsible for rendering main image.
 * It should be used to display the original image.
 */
export class MainImage extends React.PureComponent<IMainImageProps, INativeImageState> {
    /**
     * The default class for main image component.
     */
    private static _mainImageClassName: string = 'msc-main_image';

    /**
     * Initializes instance with the given props.
     * @param {IMainImageProps} props - Configuration for the main placeholder image.
     */
    public constructor(props: IMainImageProps) {
        super(props);
    }

    /**
     * Renders main image.
     */
    public render(): React.ReactNode {
        if (this.props.imageFallbackOptimize && this.props.imageSettings?.disableLazyLoad) {
            if (msdyn365Commerce.isBrowser){
                return <span
                dangerouslySetInnerHTML={{
                  __html: ''
                }}
              />
            }
            const pictureHtml = ReactDOMServer.renderToString(
                <NativeImage
                    {...this.props}
                    src={this.props.src}
                    className={classnames(MainImage._mainImageClassName, this.props.className)}
                />
            );
            /* eslint-disable react/no-danger */
            return <span dangerouslySetInnerHTML={{ __html: pictureHtml }}></span>;
        } else {
            return (
                <NativeImage
                    {...this.props}
                    src={this.props.src}
                    className={classnames(MainImage._mainImageClassName, this.props.className)}
                />
            );
        }
    }
}
